import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { subscriptionService } from 'src/services/subscriptionService';
import { ReactComponent as CreateWithManualIcon } from 'src/assets/images/onboarding-trainer/dashboard/overview/create-with-manual.svg';
import { ReactComponent as CreateWithAIIcon } from 'src/assets/images/onboarding-trainer/dashboard/overview/create-with-ai.svg';
import { ReactComponent as CreateArrowIcon } from 'src/assets/images/onboarding-trainer/dashboard/overview/create-arrow.svg';
import { ReactComponent as LogoIcon } from 'src/assets/images/onboarding-trainer/logo.svg';
import './Welcome.scss';

export const Welcome: FC = () => {
  const navigate = useNavigate();

  const handleCreateWithAi = async () => {
    try {
      const res = await subscriptionService.checkFeatureAccess(
        'ai_program_generator',
        'welcome_screen',
      );
      if (res.allowed) {
        navigate('/onboarding-trainer/dashboard/programs');
      } else {
        navigate('/onboarding-trainer/dashboard/subscription');
      }
    } catch {
      navigate('/onboarding-trainer/dashboard/subscription');
    }
  };

  const handleCreateManually = () => {
    navigate('/onboarding-trainer/dashboard/programs');
  };

  return (
    <div className="welcome-screen-container">
      <div className="welcome-header-center">
        <div className="welcome-logo-center">
          <LogoIcon />
        </div>
        <h1>{'Create personalized workout programs for your clients'}</h1>
      </div>

      <div className="welcome-action-cards">
        {/* Create with AI Card */}
        <button type="button" className="welcome-action-card ai-card" onClick={handleCreateWithAi}>
          <div className="icon-circle">
            <CreateWithAIIcon viewBox="0 0 64 64" />
          </div>
          <div className="card-title gold-title">
            <span>{'Create with Ai'}</span>
            <CreateArrowIcon />
          </div>
          <p className="card-description">{'Let AI generate a customized workout program'}</p>
        </button>

        {/* Create Manually Card */}
        <button
          type="button"
          className="welcome-action-card manual-card"
          onClick={handleCreateManually}
        >
          <div className="icon-circle">
            <CreateWithManualIcon viewBox="0 0 64 64" />
          </div>
          <div className="card-title white-title">
            <span>{'Create Manually'}</span>
            <CreateArrowIcon />
          </div>
          <p className="card-description">{'Build your workout program from scratch'}</p>
        </button>
      </div>
    </div>
  );
};
